import React from 'react';
import { useTranslate } from '@agilepoint/wat-react';
import { CenteredSpinner } from 'common/components/centered-spinner';
import { MenuOptions } from '../components';
import { useGetMenuOptionsQuery, useSaveTextDataQuery } from 'modules/shared/queries';
import { useConfigScopeSelectors } from 'modules/core/scopes';
import { getCurrentDate, ErrorInfo } from 'common';
import { IMenuOptionsFormFields } from 'modules/shared/types';

export const MenuOptionsContainer = React.memo(() => {
    const { data, isLoading, isFetching, error } = useGetMenuOptionsQuery();
    const { mutateAsync, isLoading: mutationLoading } = useSaveTextDataQuery();
    const translate = useTranslate();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();

    const onSaveCompanyDetails = React.useCallback((args: IMenuOptionsFormFields) => mutateAsync({
        BinaryData: [],
        ContentType: 'json',
        CreatedDate: getCurrentDate(),
        ELEMENTID: '',
        SecondaryReference: `AppMenus_${currentUserDetails.userName.replace(/\\/g, '_')}`,
        TextData: JSON.stringify(args)
    }), [currentUserDetails.userName, mutateAsync]);

    if (isLoading || isFetching) {
        return <CenteredSpinner spinnerType='indeterminate' size='small' text={translate('modules.createNewApp.steps.menuOptions.menuLoadingText')} />;
    }

    if (data) {
        const { TextData } = data;
        const menuOPtions = TextData ? JSON.parse(TextData) : [];

        return (
            <MenuOptions
                mutationLoading={mutationLoading}
                onSaveCompanyDetails={onSaveCompanyDetails}
                menuOptions={menuOPtions} />
        );
    }

    return (
        <ErrorInfo errorObject={error} />
    );
});
